/* eslint-disable max-lines */
import {
    PageFindChannelUsingGetParams,
    BuyerSupplierVo,
    PageFindChannelUsingGet1Params,
    GetSupplierListUsingGetParams,
    SuppliersPoolSortWeightVo,
    GetSupplierListForHomePageUsingGetParams,
    PageSupplierListUsingGet1Params,
    PageSupplierListUsingGetParams,
    ListHomeSupplierOfflineUsingGetParams,
    SupplierOfflineVo,
    QueryBrowseSupplierInfoVoUsingGet1Params,
    BuyerSupplierPcVo,
    GetSupplierInfoByCoIdUsingGetParams,
    LoadUsingGet8Params,
    CoSupplierOffline,
    QueryDictionaryListUsingGetParams,
    GylDictionary,
    GetInviteCoIdUsingGetParams,
    CompanyPartnerVo,
    QuerySupplierInfoUsingGetParams,
    VideoCompanyQueryVo,
    CompanyVideoTopVo,
    QuerySiteLogosUsingGet1Params,
    SupplierSiteLogoVo,
    BrandSiteSupplierQueryVo,
    SiteFavoritesListParam,
    SiteInFavorites,
    SiteFavoritesParam,
    GetConfirmedSupplierListUsingGetParams,
    ConfirmedSupplierVo,
    QuerySupplierListUsingGetParams,
    WaitProcessSupplierVo,
    DislikeInviteParam,
    BatchRefuseParam,
    QueryWaitHandleSupplierListUsingGetParams,
    QuerySupplierIdByCoIdUsingGetParams,
    SupplierIdByCoIdVo,
    QueryBrowseSupplierInfoVoUsingGet2Params,
    GetInviteCoIdUsingGet1Params
} from '@/services/Typings/drpRequest'
import { FeedbackParam } from '@servicesTypings/companyRequest'
import {
    CoIdAndSpuId,
    SpuDisSupplyPrice,
    CardDetailResult,
    QueryOrdinaryParamVo,
    SupplierPromoteOrdinaryItemVo,
    SupplierActivityParam,
    SupplierActivityResult,
    SupplierActivityItemParam,
    SupplierActivityItemResult,
    GoodsResult,
    InviteSupplierGoodsResult,
    SupplierSpuSaleRankListParam,
    SupplierSpuSaleRankListVo,
    QueryOfflineSpuParam,
    QueryOfflineSpuResult,
    ChannelPartnerSpuNum,
    BatchOperateSpuVo,
    FreshmanSpuSimpleResultVo,
    QueryGoodsPriceParam
} from '@servicesTypings/goodsRequest'

import { companyRequest, goodsRequest, openGoodsRequest, drpRequest, openDrpRequest } from '@/utils/request'

/**
 * 寻合作 渠道侧
 */
/**
 * 寻合作-找分销商列表
 */
export function queryFindChannelList(params: PageFindChannelUsingGetParams): API.Res<BuyerSupplierVo[]> {
    return drpRequest.get('/channel/pageFindChannel', { params })
}

/**
 * 寻合作-找分销商列表
 */
/**
 * 寻合作-找分销商列表
 */
export function queryFindChannelListV1(params: PageFindChannelUsingGet1Params): API.Res<BuyerSupplierVo[]> {
    return drpRequest.get('/findCooperation/channel/pageFindChannel', { params })
}

/**
 * 新供应链商家列表
 */
/**
 * 获取商家列表
 */
export function querySupplierList(params: GetSupplierListUsingGetParams): API.Res<BuyerSupplierVo[]> {
    return drpRequest.get('/buyer/supplier/pc/list', { params })
}

/**
 * 获取供应商商品权重
 */
/**
 * 查询寻合作找供应商商家排序系数
 */
export function querySupplierSortWeightList(data: string[]): API.Res<SuppliersPoolSortWeightVo[]> {
    return drpRequest.post('/findCooperation/supplier/querySortWeightList', { data })
}

/**
 * 获取商家列表(首页使用)
 */
/**
 * 获取合作中的商家列表(首页使用)
 */
export function getSupplierListForHomePage(
    params: GetSupplierListForHomePageUsingGetParams
): API.Res<BuyerSupplierVo[]> {
    return drpRequest.get('/buyer/supplier/pc/getSupplierListForHomePage', { params })
}

/**
 * 新供应链商家列表--新增商品名称查询
 */
/**
 * 查询供应商列表
 */
export function querySupplierListNew(params: PageSupplierListUsingGet1Params): API.Res<BuyerSupplierVo[]> {
    return drpRequest.get('/supplier/list', { params })
}

/**
 * 新供应链商家列表--新增商品名称查询
 */
/**
 * 查询供应商列表
 */
export function querySupplierListNewV1(params: PageSupplierListUsingGetParams): API.Res<BuyerSupplierVo[]> {
    return drpRequest.get('/findCooperation/supplier/list', { params })
}

/**
 * 线下合作商家列表
 */
/**
 * 供应链优选-线下自主供应商列表
 */
export function queryOfflineSupplierList(params: ListHomeSupplierOfflineUsingGetParams): API.Res<SupplierOfflineVo[]> {
    return drpRequest.get('/supplier/offline/listHomeSupplierOffline', { params })
}

/**
 * 新供应链商家详情
 */
/**
 * 渠道获取商家信息
 */
export function querySupplierInfo(params: QueryBrowseSupplierInfoVoUsingGet1Params): API.Res<BuyerSupplierPcVo> {
    return drpRequest.get('/buyer/supplier/pc/info', { params })
}

/**
 * 新供应链商家详情根据coId查
 */
/**
 * 根据coId获取供应商信息
 */
export function querySupplierInfoBycoId(params: GetSupplierInfoByCoIdUsingGetParams): API.Res<BuyerSupplierVo> {
    return drpRequest.get('/buyer/supplier/pc/getSupplierInfoByCoId', { params })
}

//  根据coId 查 SupplierId open
/**
 * 供应商coId换id
 */
export function querySupplierIdByCoIdOpen(params: QuerySupplierIdByCoIdUsingGetParams): API.Res<SupplierIdByCoIdVo> {
    return openDrpRequest.get('/open/supplier/querySupplierIdByCoId', { params })
}

/**
 * 查询商家标签
 */
export function querySupplierLabel(params) {
    return drpRequest.get('/supplier/label/queryLabel', {
        params
    })
}

/**
 * 查询商家标签-open
 */
export function queryOpenSupplierLabel(params) {
    return openDrpRequest.get('/open/supplier/label/queryLabel', {
        params
    })
}

/**
 * 线下合作商家详情
 */
/**
 * 获取线下供应商信息
 */
export function queryOfflineSupplierInfo(params: LoadUsingGet8Params): API.Res<CoSupplierOffline> {
    return drpRequest.get('/supplier/offline/load', { params })
}

/**
 * 新供应链查询主营平台
 */
/**
 * 查询字典配置列表
 */
export function queryDictionaryList(params: QueryDictionaryListUsingGetParams): API.Res<GylDictionary[]> {
    return drpRequest.get('/supplierDictionary/queryDictionaryList', { params })
}

/**
 * 新供应链商家详情(盘货表页面使用)  open
 */
/**
 * 渠道获取商家信息
 */
export function querySupplierInfoOpen(params: QueryBrowseSupplierInfoVoUsingGet2Params): API.Res<BuyerSupplierVo> {
    return openDrpRequest.get('/open/supplier/info', { params })
}

/**
 * 新供应链商家详情(商家展架页面使用)  open
 */
/**
 * 渠道获取商家信息
 */
export function getSupplierInfoOpen(params: QueryBrowseSupplierInfoVoUsingGet2Params): API.Res<BuyerSupplierVo> {
    return openDrpRequest.get('/open/supplier/info', { params })
}

// 展架 通过invitedId查询supplierId open
/**
 * 判断邀约商家是否需要提示合作
 */
export function getInviteCoId(params: GetInviteCoIdUsingGetParams): API.Res<CompanyPartnerVo> {
    return drpRequest.get('/coDisInvite/getInviteCoId', { params })
}

// 展架 通过invitedId查询supplierId open
/**
 * 判断邀约商家是否需要提示合作
 */
export function getInviteCoIdOpen(params: GetInviteCoIdUsingGet1Params): API.Res<CompanyPartnerVo> {
    return openDrpRequest.get('/open/op/disInvite/getInviteCoId', { params })
}

// 定向邀约进来的同意合作
export function buildCooper(data) {
    return drpRequest.post('/myPartner/build', { data })
}

// 寻找分销商展架详情顶部卡片的info

// coId： 供应商的CoId
// originator:  CHANNEL/SUPPLIER  发起者的身份

/**
 * 若发起者是供应商,则供应商查询分销商的供应商展架;若发起者为分销商，则分销商查看供应商的展架
 */
export function fetchSupplierPcQuerySupplierInfo(params: QuerySupplierInfoUsingGetParams): API.Res<BuyerSupplierPcVo> {
    return drpRequest.get('/buyer/supplier/pc/querySupplierInfo', { params })
}

// 客户返回提交
/**
 * submit
 */
export function feedbackApi(data: FeedbackParam): API.Res<object> {
    return companyRequest.post('/feedback/submit', { data })
}

// 查询spu价格
/**
 * 查询SPU维度分销价
 */
export function queryDisSpuPrice(data: CoIdAndSpuId[]): API.Res<SpuDisSupplyPrice[]> {
    return goodsRequest.post('/goods/queryDisSpuPrice', { data })
}

// 查询spu价格 详情
/**
 * 查询SPU维度分销价校验权限
 */
export function queryDisSpuPriceCheckPermissio(data: CoIdAndSpuId[]): API.Res<SpuDisSupplyPrice[]> {
    return goodsRequest.post('/goods/queryDisSpuPriceCheckPermission', { data })
}

// 开放： 查询spu价格详情
/**
 * 查询SPU维度分销价
 */
export function openQueryDisSpuPrice(data: CoIdAndSpuId[]): API.Res<SpuDisSupplyPrice[]> {
    return openGoodsRequest.post('/open/supplier/goods/queryDisSpuPrice', { data })
}

// 查询铺货列表、铺货平台、成交价，spu 价
/**
 * 异步查询卡片详情部分字段
 */
export function asyncQueryCardDetailFields(data: CoIdAndSpuId[]): API.Res<CardDetailResult[]> {
    return goodsRequest.post('/goods/asyncQueryCardDetailFields', { data })
}

// 查询新人专区商品简略信息
/**
 * 查询新人专区商品简略信息
 */
export function querySimpleGoods(data: BatchOperateSpuVo): API.Res<FreshmanSpuSimpleResultVo[]> {
    return openGoodsRequest.post('/open/freshman/goods/querySimpleGoods', { data })
}

// 开放查询铺货列表、铺货平台、成交价，spu 价(合伙人)
/**
 * 异步查询卡片详情部分字段V2
 */
export function openAsyncQueryCardDetailFieldsV2(data: QueryGoodsPriceParam): API.Res<CardDetailResult[]> {
    return openGoodsRequest.post('/open/supplier/goods/asyncQueryCardDetailFieldsV2', { data })
}

// 已设置探厂视频的供应商头部列表
/**
 * 已设置探厂视频的供应商列表
 */
export function topList(data: VideoCompanyQueryVo): API.Res<CompanyVideoTopVo[]> {
    return drpRequest.post('/company/videoCompany/topList', { data })
}

/**
 * 探厂视频集合页，已设置探厂视频的供应商列表
 */
/**
 * 探厂视频集合页，已设置探厂视频的供应商列表
 */
export function videoCompanyList(data: VideoCompanyQueryVo): API.Res<BuyerSupplierVo[]> {
    return drpRequest.post('/company/videoCompany/list', { data })
}

// 查询供应商的推广普通商品
/**
 * 查询供应商的推广普通商品
 */
export function querySupplierOrdinaryItem(data: QueryOrdinaryParamVo): API.Res<SupplierPromoteOrdinaryItemVo[]> {
    return goodsRequest.post('/goGoodsPromote/querySupplierOrdinaryItem', { data })
}

// 建立合作
export function normalBuildCoop(data) {
    return drpRequest.post('/partner/channel/build', { data })
}

// 根据条件查询品牌墙入口的人气甄选商家LOGO列表
/**
 * 根据条件查询品牌墙入口的人气甄选商家LOGO列表
 */
export function querySiteLogos(params: QuerySiteLogosUsingGet1Params): API.Res<SupplierSiteLogoVo[]> {
    return drpRequest.get('/supplier/querySiteLogos', { params })
}

/**
 * 获取品牌墙人气甄选商家列表
 */
export function listBrandSiteTopSupplierList(data: BrandSiteSupplierQueryVo): API.Res<BuyerSupplierVo[]> {
    return drpRequest.post('/supplier/listBrandSiteTopSupplierList', { data })
}

/**
 * 获取品牌墙品牌严选商家列表
 */
export function listBrandSiteSupplierList(data: BrandSiteSupplierQueryVo): API.Res<BuyerSupplierVo[]> {
    return drpRequest.post('/supplier/listBrandSiteSupplierList', { data })
}

// 是否已经收藏小站
/**
 * 是否已经收藏小站
 */
export function favHasAddSite(data: SiteFavoritesListParam): API.Res<SiteInFavorites[]> {
    return drpRequest.post('/favorites/hasAddSite', { data })
}

// 添加收藏小站
/**
 * 添加收藏小站
 */
export function favAddSite(data: SiteFavoritesParam): API.Res<boolean> {
    return drpRequest.post('/favorites/addSite', { data })
}

// 取消收藏小站
/**
 * 取消收藏小站
 */
export function favRemoveSite(data: SiteFavoritesParam): API.Res<boolean> {
    return drpRequest.post('/favorites/removeSite', { data })
}

// 是否有动态
export function hasSupplierActivity() {
    return goodsRequest.get('/supplierActivity/hasSupplierActivity')
}
// 查询动态数
export function countNewSupplierActivity() {
    return drpRequest.get('/partner/channel/getPromoteNewGoodsSupplierCount')
}

// 查询收藏数量
export function queryFavoritesCount() {
    return drpRequest.get('/favorites/queryFavoritesCount')
}
// 查询是否包含允许访问查找合作标签
export function queryAllowVisitFindCooperationApi() {
    return drpRequest.get('/findCooperation/channel/queryAllowVisitFindCooperation')
}
// 查询分销商是否满足选择已有合作供应商标准
export function queryChoiceSupplierConditionApi() {
    return drpRequest.get('/findCooperation/channel/queryChoiceSupplierCondition')
}
// 设置允许访问寻合作
/**
 * 设置允许访问寻合作
 */
export function setAllowVisitFindCooperationApi(): API.Res<null> {
    return drpRequest.post('/findCooperation/channel/setAllowVisitFindCooperation')
}

// 设置已有合作供应商
/**
 * 设置已有合作供应商
 */
export function setAlreadyHasCooperativeSuppliersApi(): API.Res<null> {
    return drpRequest.post('/findCooperation/channel/setAlreadyHasCooperativeSuppliers')
}

// 查询店铺是否存在
/**
 * existShop
 */
export function checkOnlineAndAuthShopExistApi(): API.Res<boolean> {
    return companyRequest.post('/sales/gylErpShopInfo/checkOnlineAndAuthShopExist')
}

// 合作商家动态
/**
 * 合作商家动态查询
 */
export function listSupplierActivity(data: SupplierActivityParam): API.Res<SupplierActivityResult> {
    return goodsRequest.post('/supplierActivity/listSupplierActivity', { data })
}

// 合作商家动态
/**
 * 获取首页，合作供应商中卡片列表
 */
export function getConfirmedSupplierList(
    params: GetConfirmedSupplierListUsingGetParams
): API.Res<ConfirmedSupplierVo[]> {
    return drpRequest.get('/partner/channel/getConfirmedSupplierList', { params })
}

// 最近有效邀约供应商列表
/**
 * 最近有效邀约供应商列表
 */
export function inviteRecentQuerySupplierList(
    params: QuerySupplierListUsingGetParams
): API.Res<WaitProcessSupplierVo[]> {
    return drpRequest.get('/inviteRecent/querySupplierList', { params })
}

// 最近有效邀约供应商列表
/**
 * 最新的邀约供应商信息
 */
export function queryLatestSupplierInfo(): API.Res<WaitProcessSupplierVo> {
    return drpRequest.get('/inviteRecent/queryLatestSupplierInfo')
}

// 暂不合作
/**
 * 暂不合作
 */
export function coDisInviteDislike(data: DislikeInviteParam): API.Res<null> {
    return drpRequest.post('/coDisInvite/dislike', { data })
}

// 批量合作
export function batchConfirm(data) {
    return drpRequest.post('/partner/channel/batchConfirm', { data })
}
// 批量不同意申请
/**
 * 批量拒绝供应商的申请
 */
export function batchRefuse(data: BatchRefuseParam): API.Res<null> {
    return drpRequest.post('/partner/channel/batchRefuse', { data })
}

// 获取首页，合作供应商中的爆款专区卡片
/**
 * 获取首页，合作供应商中的爆款专区卡片
 */
export function getHotSellInfo(): API.Res<ConfirmedSupplierVo[]> {
    return drpRequest.get('/partner/channel/getHotSellInfo')
}

// 获取top3寻合作推荐
export function supplierListTop3() {
    return drpRequest.get('/supplier/list?pageNum=1&atMe=false&pageSize=3')
}

// 合作商家动态商品查询
/**
 * 合作商家动态商品查询不包含价格
 */
export function queryListSupplierActivityItem(
    data: SupplierActivityItemParam[]
): API.Res<SupplierActivityItemResult[]> {
    return goodsRequest.post('/supplierActivity/listSupplierActivityItemV2', { data })
}

// 合作商家动态商品查询
/**
 * 查询合作供应商商品
 */
export function querySupplierGoods(data: QueryOrdinaryParamVo): API.Res<GoodsResult[]> {
    return goodsRequest.post('/homepage/querySupplierGoods', { data })
}

// 合作商家动态商品查询
/**
 * 查询邀约供应商商品
 */
export function queryInviteSupplierGoods(data: QueryOrdinaryParamVo): API.Res<InviteSupplierGoodsResult[]> {
    return goodsRequest.post('/homepage/queryInviteSupplierGoods', { data })
}

// 查询爆款专区商品
/**
 * 查询爆款专区商品
 */
export function queryFreshmanGoods(data: QueryOrdinaryParamVo): API.Res<GoodsResult[]> {
    return goodsRequest.post('/homepage/queryFreshmanGoods', { data })
}

// 查询分销商的邀约信息
export function queryChannelApplyCooperation() {
    return drpRequest.get('/findCooperation/channel/queryChannelApplyCooperation')
}
// 分销商引导展示最新邀约供应商信息
export function getChannelGuideLastInviteSupplierInfo() {
    return drpRequest.get('/channel/getChannelGuideLastInviteSupplierInfo')
}
// 定向邀约分销商弹窗显示邀约供应商信息
export function getChannelApplyCooperation() {
    return drpRequest.get('/channel/getChannelApplyCooperation')
}
// 获取新手引导中适合铺货的供应商信息
export function getSuitShelvedSupplierApi() {
    return drpRequest.get('/config/getSuitShelvedSupplier')
}

/**
 * 查询我的供应商空态默认数据
 */
export function getDefaultSupplier(): API.Res<BuyerSupplierVo[]> {
    return drpRequest.get('/supplier/getDefaultSupplier')
}

// 查询供应商销售榜
/**
 * 查询供应商销售榜
 */
export function querySupplierSpuSaleRankList(
    data: SupplierSpuSaleRankListParam[]
): API.Res<SupplierSpuSaleRankListVo[]> {
    return goodsRequest.post('/buyer/supplier/querySupplierSpuSaleRankList', { data })
}

/**
 * 获取线下供应商商品
 * @param {*} data
 * @returns
 */
/**
 * getOfflineSupplierGoodsList
 */
export function getOfflineSupplierGoodsList(data: QueryOfflineSpuParam[]): API.Res<QueryOfflineSpuResult[]> {
    return goodsRequest.post('/goods/getOfflineSupplierGoodsList', { data })
}

/**
 * 查询合作供应商spu数量
 * @param {*} data
 * @returns
 */
/**
 * queryPartnerSpuNum
 */
export function queryPartnerSpuNum(data: string[]): API.Res<ChannelPartnerSpuNum[]> {
    return goodsRequest.post('/goChannelPartnerSpu/queryPartnerSpuNum', { data })
}

/** 查询邀约待处理供应商列表 */
/**
 * 查询邀约待处理供应商列表
 */
export function queryWaitHandleSupplierList(
    params: QueryWaitHandleSupplierListUsingGetParams
): API.Res<WaitProcessSupplierVo[]> {
    return drpRequest.get('/partner/channel/queryWaitHandleSupplierList', { params })
}

/** 查询爆款专区邀约商品 */
/**
 * 查询爆款专区商品
 */
export function queryInviteFreshmanGoods(data: QueryOrdinaryParamVo): API.Res<GoodsResult[]> {
    return goodsRequest.post('/homepage/queryInviteFreshmanGoods', { data })
}
